import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MediaService } from '../../media.service';
import { Bucket, File } from '@appbolaget/aware-model';
import { MatIconModule } from '@angular/material/icon';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgIf } from '@angular/common';

@Component({
    selector: 'aw-file-list',
    templateUrl: 'file-list.component.html',
    styleUrls: ['./file-list.component.scss'],
    standalone: true,
    imports: [NgIf, NgxDatatableModule, MatIconModule],
})
export class FileListComponent implements OnInit {
    SHOW_TABLE: boolean;

    _items: Array<File | Bucket>;
    _display: boolean;

    columns = [
        { prop: 'title', name: 'Namn', flexGrow: 2 },
        { prop: 'mime', name: 'Typ', flexGrow: 1 },
        { prop: 'size', name: 'Storlek', flexGrow: 1 },
    ];

    @Input('display')
    set display(display) {
        this._display = display;

        if (this.display) {
            this.SHOW_TABLE = true;
        } else {
            this.SHOW_TABLE = false;
        }
    }

    get display() {
        return this._display;
    }

    @Input('items')
    set items(items) {
        this._items = items;
    }

    get items() {
        return this._items;
    }

    @Input() selectedItems: Set<File | Bucket> = new Set();

    @Output() select = new EventEmitter();
    @Output() doubleClick = new EventEmitter<Bucket>();

    getRowClass = (row) => {
        return {
            'row-selected': this.isSelected(row),
        };
    };

    constructor(public mediaService: MediaService) {}

    ngOnInit() {}

    rowSelected($event) {
        if ($event.type === 'dblclick') {
            this.doubleClick.emit($event.row);
        } else if ($event.type === 'click' || $event.type === 'keydown') {
            this.select.emit($event);
        }
    }

    isSelected(item): boolean {
        return this.selectedItems.has(item);
    }
}
